import { toast } from 'sonner';

// Une écriture refusée par le serveur (conflit de version 409 du correctif ZIP19,
// droits 403, base indisponible) ne doit JAMAIS passer inaperçue : `store.js`
// conserve le brouillon du poste, l'utilisateur doit savoir que rien n'a été
// enregistré et qu'il faut recharger avant de ressaisir.
export async function sansPerte(action) {
  try {
    return { error: null, valeur: await action() };
  } catch (e) {
    const message =
      e?.statut === 409
        ? 'Conflit : ces données ont changé sur le serveur. RIEN n’a été enregistré — rechargez la base puis ressaisissez (votre saisie reste conservée sur ce poste).'
        : `Enregistrement NON CONFIRMÉ : ${String(e?.message || e)} — vérifiez la base avant de ressaisir.`;
    toast.error(message, { duration: 12000 });
    return { error: message, valeur: null };
  }
}
